import { useQuery } from 'react-query';
import { api, get } from '../../lib/api';

export const createAccount = data => {
  return api({
    method: 'post',
    url: '/api/guest_user_conversions',
    data,
  });
};

export const useGetBoardInfo = () => {
  const { data = {} } = useQuery('boardInfo', () =>
    get('/api/guest_user_conversions/demo_info'),
  );

  return { data: data.demo };
};
